import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl, intlShape } from '../../util/reactIntl';
import { Modal, NamedLink, PrimaryButton } from '../../components';

import css from './ProviderOnboardingRequiredModal.css';

const { bool, func, string } = PropTypes;

// Non-closeable modal shown on TransactionPage when a provider is missing
// prerequisites (tax information and/or a fully onboarded Stripe account)
// before they can interact with a conversation.
const ProviderOnboardingRequiredModal = props => {
  const {
    id,
    isOpen,
    onManageDisableScrolling,
    missingTax,
    missingStripe,
    missingVatStatus,
  } = props;

  return (
    <Modal id={id} isOpen={isOpen} onManageDisableScrolling={onManageDisableScrolling} usePortal>
      <div className={css.content}>
        <h2 className={css.title}>
          <FormattedMessage id="ProviderOnboardingRequiredModal.title" />
        </h2>

        <p className={css.description}>
          <FormattedMessage id="ProviderOnboardingRequiredModal.description" />
        </p>

        <ul className={css.requirements}>
          {missingTax ? (
            <li className={css.requirement}>
              <div className={css.requirementText}>
                <FormattedMessage id="ProviderOnboardingRequiredModal.missingTax" />
              </div>
              <NamedLink name="TaxInformationPage" className={css.ctaLink}>
                <PrimaryButton type="button" className={css.cta}>
                  <FormattedMessage id="ProviderOnboardingRequiredModal.taxCta" />
                </PrimaryButton>
              </NamedLink>
            </li>
          ) : null}

          {missingVatStatus ? (
            <li className={css.requirement}>
              <div className={css.requirementText}>
                <FormattedMessage id="ProviderOnboardingRequiredModal.missingVatStatus" />
              </div>
              <NamedLink name="TaxInformationPage" className={css.ctaLink}>
                <PrimaryButton type="button" className={css.cta}>
                  <FormattedMessage id="ProviderOnboardingRequiredModal.taxCta" />
                </PrimaryButton>
              </NamedLink>
            </li>
          ) : null}

          {missingStripe ? (
            <li className={css.requirement}>
              <div className={css.requirementText}>
                <FormattedMessage id="ProviderOnboardingRequiredModal.missingStripe" />
              </div>
              <NamedLink name="StripePayoutPage" className={css.ctaLink}>
                <PrimaryButton type="button" className={css.cta}>
                  <FormattedMessage id="ProviderOnboardingRequiredModal.stripeCta" />
                </PrimaryButton>
              </NamedLink>
            </li>
          ) : null}
        </ul>
      </div>
    </Modal>
  );
};

ProviderOnboardingRequiredModal.defaultProps = {
  missingTax: false,
  missingStripe: false,
  missingVatStatus: false,
};

ProviderOnboardingRequiredModal.propTypes = {
  id: string.isRequired,
  isOpen: bool.isRequired,
  onManageDisableScrolling: func.isRequired,
  missingTax: bool,
  missingStripe: bool,
  missingVatStatus: bool,
  intl: intlShape.isRequired,
};

export default injectIntl(ProviderOnboardingRequiredModal);
